'use client';

import { createContext, useContext } from 'react';

var MultipleRadioGroupContext = createContext({});
var useMultipleRadioGroupContext = function () { return useContext(MultipleRadioGroupContext); };
var MAX_ADDITIONAL_ITEMS = 3;

export { MAX_ADDITIONAL_ITEMS, MultipleRadioGroupContext, useMultipleRadioGroupContext };
//# sourceMappingURL=context.js.map
